<template>
  <div id="app">
    <router-view />
  </div>
  <!-- <el-container> -->
  <!--<el-header>-->
  <!--<img class="header-logo" src="@/assets/logo.png"/>-->
  <!--<el-menu-->
  <!--:default-active="$route.path"-->
  <!--class="header-menu"-->
  <!--mode="horizontal"-->
  <!--:active="$route.path"-->
  <!--router>-->
  <!--<el-menu-item index="/">网站管理</el-menu-item>-->
  <!--<el-menu-item index="/template">模板管理</el-menu-item>-->
  <!--<el-menu-item index="/system">系统管理</el-menu-item>-->
  <!--</el-menu>-->
  <!--</el-header>-->
  <!-- <el-container> -->

  <!--<el-footer>-->
  <!--<p class="content">权限开通请发送邮件至pm@ijunhai.com，抄送给相关业务负责人</p>-->
  <!--<p class="content">2014©广州君海网络科技有限公司</p>-->
  <!--</el-footer>-->
  <!-- </el-container>
  </el-container> -->
</template>

<script>
import axios from 'axios';
import api from './api/api';

export default {
  name: 'App',
  mounted() {
    axios
      .get(`${api.url}getPublicUrl`)
      .then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          localStorage.setItem('ENV_ONLINE', data.ENV_ONLINE);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style lang="less">
body {
  background: #f2f2f2;
}

.table-container {
  box-sizing: border-box;
  padding: 16px;
  box-shadow: 0px 2px 6px 1px rgba(56, 132, 194, 0.1);
  background: #fff;
  border-radius: 4px;
  .el-button--mini {
    float: right;
    margin: 0 0 16px 16px;
  }
  .el-input {
    width: 60px;
  }
}
.table-btn {
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
  margin: 0 5px;
}
.table-btn.delete {
  color: #f56c6c;
}
.required {
  color: red;
}
.el-table:before {
  height: 0;
}
.el-col-3,
.el-col-10 {
  padding-left: 20px;
  text-align: left;
}
.btn {
  margin-bottom: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
p {
  margin: 0;
}
.el-form .el-form-item__label {
  text-align: left;
  color: #606266;
  font-weight: 500;
}
.el-form-item__content .el-input,
.el-select {
  width: 400px;
  height: 28px;
  line-height: 28px;
}

.el-form .el-form-item {
  margin: 8px 8px 8px 0;
}

.form-wrapper {
  height: ~"calc(100vh - 186px)";
  overflow: auto;
  margin: 16px 16px 0;
  background: #fff;
  box-shadow: 0px 2px 6px 1px rgba(56, 132, 194, 0.1);
  padding: 16px 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  .disabled {
    /deep/ .el-upload--picture-card {
      display: none;
    }
  }
  .el-form-item__content .el-input,
  .el-select {
    width: 300px;
    height: 28px;
    line-height: 28px;
  }
  .el-form-item__content .el-form-item__error {
    padding-top: 0px;
    top: 90%;
  }
  .num-input {
    width: 90px !important;
    input[type="number"] {
      width: 60px;
    }
  }
}
.warning-span {
  color: red;
}
@media screen and(max-width:750px) {
  .form-wrapper {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue